import { render } from "./tabSlot.vue?vue&type=template&id=d6f2396c&scoped=true"
import script from "./tabSlot.vue?vue&type=script&lang=js"
export * from "./tabSlot.vue?vue&type=script&lang=js"

import "./tabSlot.vue?vue&type=style&index=0&id=d6f2396c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f2396c"]])

export default __exports__